module.exports = __webpack_public_path__ + "715b33f6.png";